import { RefreshCw } from "lucide-react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { formatDateTime } from "@helpers/date";

// The brand dashboard is served from a cache — show how old it is, and let Ops rebuild it.
const FreshnessBar = ({ generatedAt, refreshing, onRefresh }) => (
    <div className="flex flex-wrap items-center justify-between gap-2">
        <p className="text-sm text-muted">
            Figures as of <span className="font-medium text-gray-700">{generatedAt ? formatDateTime(generatedAt) : "—"}</span>
        </p>
        <button
            type="button"
            onClick={onRefresh}
            disabled={refreshing}
            className="inline-flex items-center gap-1.5 rounded-lg border border-gray-300 bg-white px-3 py-1.5 text-xs font-medium text-gray-700 transition-colors hover:bg-gray-50 disabled:opacity-60">
            <RefreshCw className={classnames("h-3.5 w-3.5", { "animate-spin": refreshing })} />
            {refreshing ? "Refreshing…" : "Refresh"}
        </button>
    </div>
);

FreshnessBar.propTypes = {
    generatedAt: PropTypes.string,
    refreshing : PropTypes.bool,
    onRefresh  : PropTypes.func.isRequired
};

export default FreshnessBar;
